import { MyFleetAemEndPoint, MyFleetLabelsEndpointRoutes } from './definitions/myfleet.interface';


export class MyFleetEndpointFactory 
{
	public static build(baseUrl: string): MyFleetAemEndPoint 
	{
		return {
			baseUrl: baseUrl,
			routes: this.buildRoutes(baseUrl)
		};
	}
	private static buildRoutes(baseUrl: string): MyFleetLabelsEndpointRoutes 
	{
		return {
			myfleet: {
				toString: () => `${baseUrl}v0/api/`,
				myfleetlabels: {
					toString: () => `${baseUrl}v0/aemfleetpage/my-fleet-labels`
				}
				
			}
		} as MyFleetLabelsEndpointRoutes;
	}
}
